import { TOGGLE_NAV } from './types';

const toggleNav = () => ({
  type: TOGGLE_NAV
});

export default toggleNav;



// WEBPACK FOOTER //
// ./src/actions/toggleNav.js